/** @module ProductPresentation/ProductPresentationForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/enums",
	"csi/def/Field",
	"csi/form/Widget"
], function(declare, lang, enums, Field, Widget) {

	return declare(Widget, {
		PRODUCT_TYPE: "ProductType",

		/**
		 * @override
		 * Insert Product Type field if it doesn't already exist
		 */
		_resolveView: function() {
			if (!this.getField(this.PRODUCT_TYPE)) {
				this.insertField(lang.mixin(new Field(), {
					m_id: this.PRODUCT_TYPE
				}), 0);
			}
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Ensure that FormulatedMaterial is not available under Product Type field
		 */
		getFieldStore: function(field, value) {
			if (field.getControlName() == this.PRODUCT_TYPE) {
				return enums.getStore(field.getEnumId(), null, (value) => value !== "ProductType:FormulatedMaterial");
			}
			return this.inherited(arguments);
		}
	});
});
